import SurveySerializer from '../serializers/SurveysSerializers';
import {StartSurveyPayload} from '../types/SurveyTypes';

import * as api from '../../../../../lib/api/v1/index';
import {ApiResponseError} from '../../../../../lib/api/v1/types';

export class SurveyService {
  // -- POST --
  async startSurvey(companyID: string, surveyPayload: StartSurveyPayload) {
    try {
      const response = await api.createCompanySurvey(companyID, surveyPayload);
      const body = await response.json();

      if (response.ok) {
        const survey = SurveySerializer.toObjectResponseCreate(body);
        return {
          ok: true,
          data: survey,
          error: undefined,
        };
      }
      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }

  // -- PATCH --
  async updateSurvey(companyId: string, surveyId: string, surveyPayload: StartSurveyPayload) {
    try {
      const response = await api.updateCompanySurvey(companyId, surveyId, surveyPayload);
      const body = await response.json();

      if (response.ok) {
        const survey = SurveySerializer.toObjectResponseCreate(body);
        return {
          ok: true,
          data: survey,
          error: undefined,
        };
      }
      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }

  async completeSurvey(companyId: string, surveyId: string) {
    try {
      const response = await api.completeCompanySurvey(companyId, surveyId);
      const body = await response.json();

      if (response.ok) {
        const survey = SurveySerializer.toObjectResponseCreate(body);
        return {
          ok: true,
          data: survey,
          error: undefined,
        };
      }
      return {
        ok: false,
        data: undefined,
        error: body as ApiResponseError,
      };
    } catch (error: any) {
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }
}
